import React from 'react';
import { Link } from "react-router-dom";
import { useTranslate } from 'context/LanguageContext';

export default function HeaderBottom() {
	
	const translate = useTranslate();

	return (
		<div className="header__bottom">
			<Link to="/"> { translate( "booking_an_appointment" )} </Link>
		</div>
	)
}

